import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-700.css';
import '@fontsource/inter/latin-800.css';
import '@fontsource/inter/latin-900.css';
import '@fontsource/inter/cyrillic-400.css';
import '@fontsource/inter/cyrillic-500.css';
import '@fontsource/inter/cyrillic-600.css';
import '@fontsource/inter/cyrillic-700.css';
import '@fontsource/inter/cyrillic-800.css';
import '@fontsource/inter/cyrillic-900.css';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import './styles.css';

import { App } from './App';
import { consumeTokenFromUrl } from './auth/session';
import { registerServiceWorker } from './pwa';
import { theme } from './theme';

consumeTokenFromUrl();
registerServiceWorker();

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            staleTime: 15_000,
            refetchOnWindowFocus: true,
        },
    },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <MantineProvider theme={theme} defaultColorScheme="dark">
            <QueryClientProvider client={queryClient}>
                <ModalsProvider labels={{ confirm: 'OK', cancel: 'Отмена' }}>
                    <Notifications position="top-right" />
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </ModalsProvider>
            </QueryClientProvider>
        </MantineProvider>
    </React.StrictMode>
);
